export const ITINERARY_REQUEST_FORM_TITLE = 'Itinerary Request';

/** CMS の CTA リンクで問い合わせドロワーを開くためのハッシュ（URL の hash または link の末尾で使用） */
export const ITINERARY_REQUEST_HASH = '#itinerary-request';

/**
 * リンクが問い合わせドロワー用（#itinerary-request）かどうかを判定する。
 * 旅程ページの CTA でこのリンクが指定されていた場合、遷移せずドロワーを開くために使用する。
 */
export function isItineraryRequestLink(link: string): boolean {
  return link.endsWith(ITINERARY_REQUEST_HASH) || link === ITINERARY_REQUEST_HASH;
}
